import styled from 'styled-components'
import { CommonLinkButton } from 'components/Button'
import { Font12, Font14 } from 'components/Typography'
import { WhiteBlock } from 'components/Layout'
import theme from 'theme_'
import Icon from '@mdi/react'
import { Button } from 'features/domains/components/AddButton/styles'
import { StyledBodyTd } from 'components/Table/styles'

export const StyledUploadFileButton = styled(CommonLinkButton)`
  ${Font12};
  font-weight: 600;
  text-transform: uppercase;
`

export const StyledConfigHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`

export const StyledConfigFooter = styled.div`
  text-align: center;
  margin-top: 40px;
`

export const StyledConfigName = styled.div`
  align-items: center;
  display: flex;
  ${Font14};
  font-weight: 600;

  span {
    flex: 1;
    margin-left: 20px;
    word-break: break-word;
  }
`

export const HomeConfigurationWhiteBlock = styled(WhiteBlock)<{
  progress?: number
}>`
  width: 100%;
  ${({ progress }) =>
    progress &&
    `
      background: ${theme.colors.hover10};
      border: 1px solid rgba(255, 95, 0, 0.5);
    `}
`
export const ConfigMobileCardContainer = styled.div`
  display: flex;
  justify-content: space-between;
  font-weight: 600;
`
export const ConfigMobileCardTitle = styled.div`
  display: flex;
  gap: 10px;
  word-break: break-word;
`
export const ConfigMobileCardLabelWrapper = styled.div`
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  > span {
    font-size: 12px;
    color: ${theme.colors.darkeyGrey};
  }
`

export const HomeConfigPlusOpenModalIcon = styled(Icon)``

export const HomeConfigPlusOpenModalIconButton = styled(Button)`
  background-color: none;
  border: none;
  order: 3;
  &:hover {
    border: none;
    opacity: 0.7;
  }
  @media ${theme.devices.tablet} {
    order: unset;
    display: none;
  }
`

export const ConfigKebabContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
  padding: 10px;
  svg {
    display: none;
  }
`

export const ConfigFilesStyledButton = styled(Button)`
  display: none;
  @media ${theme.devices.tablet} {
    display: block;
  }
`

export const HomeConfigurationContainer = styled.div`
  ${StyledBodyTd} {
    :last-child {
      justify-content: flex-end;
    }
  }
`

export const HomeDeploymentsActionsCellBody = styled.div<{
  isLoading: boolean
}>`
  display: ${({ isLoading }) => (isLoading ? 'none' : 'flex')};
  align-items: center;
`
